import InformTeamModal from './InformTeamModal';

export default InformTeamModal;
